import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4bsvx2h8w: FaireProductEntity = {
  token: "p_b4bsvx2h8w",
  type: "product",
  name: "Ceramic Nativity Cross Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/8ce49fccadb6edafa8f628b362429a1efd8340aeb3be603dfac0388586d60095.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e74c653793fb3082342814d4c412cabe024dfd5aa2fd94ee1d8124116254c05c.jpeg",
    "https://cdn.faire.com/fastly/9f0acb54eedf4193c313f508eb43d467734bca5e9dd6e5b1f26f9d81c3a865af.jpeg"
  ],
  priceDollars: 11,
  description: "A hanging décor piece from our Nativity Collection featuring a ceramic cross design displaying a nativity scene sculpted into the cross with metallic gold accents. Our Ceramic Cross hanging decor is ready to hang for display using the predrilled holes on the back. A nativity home accent perfect for seasonal display.",
  tags: [],
  msrpDollars: 21.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:30.589Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
